"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }/*!
 * name: @jswork/fetch-mp
 * description: Fetch for wechat mini program.
 * homepage: https://js.work
 * version: 1.0.4
 * date: 2025-07-03 11:11:24
 * license: MIT
 */



// src/index.ts
var _normalizeminaoptions = require('@jswork/normalize-mina-options'); var _normalizeminaoptions2 = _interopRequireDefault(_normalizeminaoptions);
function generateResponse(res) {
  let header = res.header || {};
  let config = res.config || {};
  return {
    ok: (res.statusCode / 200 | 0) === 1,
    // 200-299
    status: res.statusCode,
    statusText: res.errMsg,
    url: config.url,
    clone: () => generateResponse(res),
    text: () => Promise.resolve(typeof res.data === "string" ? res.data : JSON.stringify(res.data)),
    json: () => {
      if (typeof res.data === "object") return Promise.resolve(res.data);
      let json = {};
      try {
        json = JSON.parse(res.data);
      } catch (err) {
        console.error(err);
      }
      return json;
    },
    blob: () => Promise.resolve(new Blob([res.data])),
    headers: {
      keys: () => Object.keys(header),
      entries: () => {
        let all = [];
        for (let key in header) {
          if (header.hasOwnProperty(key)) {
            all.push([key, header[key]]);
          }
        }
        return all;
      },
      get: (n) => header[n.toLowerCase()],
      has: (n) => n.toLowerCase() in header
    }
  };
}
var fetchMp = (url, options) => {
  const normalizeOptions = { ...options, minaFramework: "mina" };
  const minaOptions = _normalizeminaoptions2.default.call(void 0, normalizeOptions);
  if (typeof wx === "undefined" || !wx.request) return Promise.resolve();
  return new Promise((resolve, reject) => {
    wx.request({
      url,
      ...minaOptions,
      success: (res) => {
        resolve(generateResponse(res));
      },
      fail: (err) => {
        reject(generateResponse(err));
      }
    });
  });
};
var index_default = fetchMp;


exports.default = index_default;

module.exports = exports.default;
